import React, { useState } from 'react';
import styled from 'styled-components';
import Modal from 'components/UI/Modal';
import FlexboxContainer from 'components/UI/FlexboxContainer';
import { Text } from 'styles/themeColors';
import { FontWeight } from 'lib/styles';
import { TEXT_LABELS } from 'constants/order';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTime } from 'luxon';
import ShippingCarrier from 'data/ShippingCarrier';
import Select from 'components/UI/Select';
import Input from 'components/UI/Input';

const LabelText = styled.span<any>`
  display: block;
  font-weight: ${FontWeight.medium};
  text-align: left;
  margin-bottom: 5px;
  color: ${Text.primary};
  font-size: 15px;
  color: ${({ color }) => color || 'inherit'};
  font-style: ${({ italic }) => (italic ? 'italic' : 'normal')};
`;


export interface Props {
  show: boolean;
  onClose: () => void;
  onConfirm: (value: string) => void;
  title: string;
  disabled?: boolean;
  carrier?: string;
  setCarrier?: (event: any) => void;
  trackingId?: string;
  setTrackingId?: (trackingId: string) => void;
  estDate?: string;
  setEstDate?: (date: string) => void;
  isShipping: boolean;
  shippingCarriers?: ShippingCarrier[];
  isRentalModificationRequired?: boolean;
  weekdaysOnly: boolean;
};

const ModifyEstDateWithRentaModal = ({
  show,
  onClose,
  onConfirm,
  title,
  disabled = false,
  carrier,
  setCarrier,
  trackingId,
  setTrackingId,
  estDate,
  setEstDate,
  isShipping,
  shippingCarriers = []
}: Props) => {
  const [openDatePicker, setOpenDatePicker] = useState(false);

  return (
    <Modal
      showButtons
      showModal={show}
      title={title}
      onClose={onClose}
      onClick={onConfirm}
      disabled={disabled}
      ghostButtonText={'Cancel'}
      primaryButtonText={'Confirm'}
      width='576px'
      left='35%'
    >
      <FlexboxContainer flexDirection="column" gap='16px'>
        {
          isShipping ?
            <FlexboxContainer flexDirection='row' gap='4px'>
              <Select
                noBoxShadow
                options={shippingCarriers.map(shCarrier => ({ value: shCarrier.name }))}
                value={carrier}
                defaultValue="Select"
                onChange={setCarrier!}
                labelPosition='top'
                label="Carrier"
                width="100%"
                height="36px"
              />
              <Input
                id="tracking-id"
                labelName="Tracking #"
                placeholder="Enter tracking number"
                value={trackingId}
                onChange={(e) => setTrackingId?.(e.target.value)}
                maxLength="25"
                separation='5px'
              />
              <FlexboxContainer flexDirection="column" width='100%' margin='3px 0px'>
                <LabelText>{TEXT_LABELS.ESTIMATED_DELIVERY}</LabelText>
                <DatePicker
                  value={estDate ? DateTime.fromISO(estDate) : null}
                  format="yyyy MMM dd"
                  open={openDatePicker}
                  onOpen={() => setOpenDatePicker(true)}
                  onClose={() => setOpenDatePicker(false)}
                  slotProps={{
                    textField: {
                      variant: 'outlined',
                      size: 'small',
                      onClick: () => setOpenDatePicker(true),
                      InputProps: {
                        readOnly: true,
                        sx: { cursor: 'pointer' }
                      }
                    }
                  }}
                  onChange={(date: DateTime | null) => setEstDate?.(date?.toISO() || '')}
                />
              </FlexboxContainer>
            </FlexboxContainer> :
            <FlexboxContainer flexDirection='row' gap='4px'>
              <Input
                id="reference-id"
                labelName="Reference #"
                placeholder="Enter reference number"
                value={trackingId}
                onChange={(e) => setTrackingId?.(e.target.value)}
                maxLength="50"
                separation='5px'
              />
              <FlexboxContainer flexDirection="column" width='100%' margin='3px 0px'>
                <LabelText>{TEXT_LABELS.READY_FOR_PICKUP}</LabelText>
                <DatePicker
                  value={estDate ? DateTime.fromISO(estDate) : null}
                  format="yyyy MMM dd"
                  open={openDatePicker}
                  onOpen={() => setOpenDatePicker(true)}
                  onClose={() => setOpenDatePicker(false)}
                  slotProps={{
                    textField: {
                      variant: 'outlined',
                      size: 'small',
                      onClick: () => setOpenDatePicker(true),
                      InputProps: {
                        readOnly: true,
                        sx: { cursor: 'pointer' }
                      }
                    }
                  }}
                  onChange={(date: DateTime | null) => setEstDate?.(date?.toISO() || '')}
                />
              </FlexboxContainer>
            </FlexboxContainer>
        }

      </FlexboxContainer>
    </Modal>
  );
};

export default ModifyEstDateWithRentaModal;
